import { toSlug } from 'commons/utils/string.utils';
import { DeviceTypeDetails, DeviceTypeDetailsAPI, DeviceTypeDetailsUpdateAPI } from '../api/device-type.api';

export const mapDeviceTypeDetailsFromModelToApi = (
    deviceTypeDetails: DeviceTypeDetails
): DeviceTypeDetailsUpdateAPI => ({
    id: deviceTypeDetails.id,
    settings: {
        operatorListMode: deviceTypeDetails.operatorListMode,
    },
});

export const mapDeviceTypeDetailsFromApiToModel = (deviceTypeDetails: DeviceTypeDetailsAPI): DeviceTypeDetails => ({
    id: deviceTypeDetails.id,
    name: deviceTypeDetails.name,
    slug: toSlug(deviceTypeDetails.name),
    supportOperatorsList:
        deviceTypeDetails.settings.supportIncrementalOperatorLists ||
        deviceTypeDetails.settings.supportFullOperatorLists,
    operatorListMode: deviceTypeDetails.settings.operatorListMode,
    maximumOperators: deviceTypeDetails.settings.maximumOperators,
    resultTypes: deviceTypeDetails.resultTypes,
});
